/**
 * Authenticated JSON fetch against a platform worker.
 *
 * Shared by the CLI commands that call the api-worker as the logged-in user
 * (`domain`, `feedback`, …). Sends a Bearer token, parses the JSON body, and
 * surfaces the worker's `{ error }` message (falling back to raw text) on a
 * non-2xx response so callers get a useful error rather than a bare status.
 */
export async function apiFetch<T>(
  baseUrl: string,
  token: string,
  path: string,
  init?: RequestInit,
): Promise<T> {
  const res = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  })
  const text = await res.text()
  if (!res.ok) {
    let msg = text
    try {
      msg = (JSON.parse(text) as { error?: string }).error ?? text
    } catch {
      // not JSON
    }
    throw new Error(`API ${path} (${res.status}): ${msg}`)
  }
  return JSON.parse(text) as T
}
